/* ===============================================
  #URL parser
================================================== */

  /*! js-url - v2.5.0 - 2017-04-22 */
  !function(){var a=function(){function a(){}function b(a){return decodeURIComponent(a.replace(/\+/g," "))}function c(a,b){var c=a.charAt(0),d=b.split(c);return c===a?d:(a=parseInt(a.substring(1),10),d[a<0?d.length+a:a-1])}function d(a,c){for(var d=a.charAt(0),e=c.split("&"),f=[],g={},h=[],i=a.substring(1),j=0,k=e.length;j<k;j++)if(f=e[j].match(/(.*?)=(.*)/),f||(f=[e[j],e[j],""]),""!==f[1].replace(/\s/g,"")){if(f[2]=b(f[2]||""),i===f[1])return f[2];h=f[1].match(/(.*)\[([0-9]+)\]/),h?(g[h[1]]=g[h[1]]||[],g[h[1]][h[2]]=f[2]):g[f[1]]=f[2]}return d===a?g:g[i]}return function(b,e){var f,g={};if("tld?"===b)return a();if(e=e||window.location.toString(),!b)return e;if(b=b.toString(),f=e.match(/^mailto:([^\/].+)/))g.protocol="mailto",g.email=f[1];else{if((f=e.match(/(.*?)\/#\!(.*)/))&&(e=f[1]+f[2]),(f=e.match(/(.*?)#(.*)/))&&(g.hash=f[2],e=f[1]),g.hash&&b.match(/^#/))return d(b,g.hash);if((f=e.match(/(.*?)\?(.*)/))&&(g.query=f[2],e=f[1]),g.query&&b.match(/^\?/))return d(b,g.query);if((f=e.match(/(.*?)\:?\/\/(.*)/))&&(g.protocol=f[1].toLowerCase(),e=f[2]),(f=e.match(/(.*?)(\/.*)/))&&(g.path=f[2],e=f[1]),g.path=(g.path||"").replace(/^([^\/])/,"/$1"),b.match(/^[\-0-9]+$/)&&(b=b.replace(/^([^\/])/,"/$1")),b.match(/^\//))return c(b,g.path.substring(1));if(f=c("/-1",g.path.substring(1)),f&&(f=f.match(/(.*?)\.(.*)/))&&(g.file=f[0],g.filename=f[1],g.fileext=f[2]),(f=e.match(/(.*)\:([0-9]+)$/))&&(g.port=f[2],e=f[1]),(f=e.match(/(.*?)@(.*)/))&&(g.auth=f[1],e=f[2]),g.auth&&(f=g.auth.match(/(.*)\:(.*)/),g.user=f?f[1]:g.auth,g.pass=f?f[2]:void 0),g.hostname=e.toLowerCase(),"."===b.charAt(0))return c(b,g.hostname);a()&&(f=g.hostname.match(a()),f&&(g.tld=f[3],g.domain=f[2]?f[2]+"."+f[3]:void 0,g.sub=f[1]||void 0)),g.port=g.port||("https"===g.protocol?"443":"80"),g.protocol=g.protocol||("443"===g.port?"https":"http")}return b in g?g[b]:"{}"===b?g:void 0}}();"function"==typeof window.define&&window.define.amd?window.define("js-url",[],function(){return a}):("undefined"!=typeof window.jQuery&&window.jQuery.extend({url:function(a,b){return window.url(a,b)}}),window.url=a)}();

window.theme_b2c = window.theme_b2c || {};
Shopify.queryParams = {};
Shopify.queryParams.sort_by = undefined;
/* Add one or more listeners to an element
** @param {DOMElement} element - DOM element to add listeners to
** @param {string} eventNames - space separated list of event names, e.g. 'click change'
** @param {Function} listener - function to attach for each event as a listener
*/
function addListenerMulti(element, eventNames, listener) {
  var events = eventNames.split(' ');
  for (var i=0, iLen=events.length; i<iLen; i++) {
    element.addEventListener(events[i], listener, false);
  }
}
function arrayRemove(arr, value) { 

  return arr.filter(function(ele){ 
    return ele != value; 
  });
}


function copyToClipboard(elementId) {

  // Create a "hidden" input
  var aux = document.createElement("input");

  // Assign it the value of the specified element
  aux.setAttribute("value", document.getElementById(elementId).innerHTML);

  // Append it to the body
  document.body.appendChild(aux);

  // Highlight its content
  aux.select();

  // Copy the highlighted text
  document.execCommand("copy");

  // Remove it from the body
  document.body.removeChild(aux);

}

show_filter = function(sortby=false){
  if(sortby== false){
    var ele = '#collection-b2c-filter';
    if(!$(ele).hasClass('active')){
      $(ele).addClass('active')
      $('body').addClass('active-filter');
      $("#myOverlay").fadeIn();
    }
  }
  else{
    var ele = '#collection-b2c-sortby';
    if(!$(ele).hasClass('active')){
      $(ele).addClass('active')
      $('body').addClass('active-filter');
      $("#myOverlay").fadeIn();
    }
  }
};
hide_filter = function(sortby=false){
  if(sortby== false){
    var ele = '#collection-b2c-filter';
    if($(ele).hasClass('active')){
      $(ele).removeClass('active');
      $('body').removeClass('active-filter');
      $("#myOverlay").fadeOut();
    }
  }
  else{
    var ele = '#collection-b2c-sortby';
    if($(ele).hasClass('active')){
      $(ele).removeClass('active');
      $('body').removeClass('active-filter');
      $("#myOverlay").fadeOut();
    }
  }
};

theme_b2c = {

  featuredTextNumber:function(ele, duration){
    var duration = duration;
    var settings = {
      animation_time:(duration*100)
    };
    var quotes = $(ele).find('.js-animated-text-placeholder');
    var quoteIndex = -1;
    function showNextQuote() {
      ++quoteIndex;
      quotes.eq(quoteIndex % quotes.length)
      .fadeIn(settings.animation_time)
      .delay(settings.animation_time/2)
      .fadeOut(settings.animation_time, showNextQuote);
    }
    showNextQuote();
  },
  initFeaturedText:function(){
    var selecors = document.querySelectorAll('.featured-text-number-b2c');
    if(selecors){
      selecors.forEach(el => {
        var duration = parseInt(el.querySelector('.js-animated-text').dataset.animatedDuration);
        if(duration){
          theme_b2c.featuredTextNumber(el,duration);
        }
      });
    }
  },

  odometerFunc : function(eles){
    var els = document.querySelectorAll(eles);
    
     els.forEach(ele => {
       var numb = parseFloat(ele.dataset.num);
       var time = parseInt($(ele).parents('.counter-wrapper').attr('data-animated-duration')) * 1000;
       $(ele).numanimate({from: 0, to: numb, time: time,
                          onStart:function(){$(this).parents('.stats').addClass('active')},
                          format: theme_b2c.formatNumbers});
     })
//     
//     $('.js-counter').counterUp({
//       offset:80,
//       onStart:function(){
// //         console.log('called started',)
//         $(this).parents('.stats').addClass('active');
//       },
//       formatter: function (n) {
//         return theme_b2c.formatNumbers(n,1);
//       }
//     });
  },
  formatNumbers : function(value,digits=1){
    var sep = $(this.element).attr('data-sepator') || false;
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "K" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" }
    ];
    var num = value;
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function(item) {
      return num >= item.value;
    });
    var comma_number = num.toFixed(1).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
//     console.log(comma_number)
    if(sep==","){
      return comma_number;
    }
    else{
      return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    }
  },
  scrollToDiv : function(eles,duration,direct=false){
    if (!Array.isArray(eles)) {
      eles = [eles];
    }
    if(direct==false){
      document.querySelectorAll(eles).forEach(ele => {
        $(ele).on('click',function(){
          var target = ele.dataset.target;
          //         console.log(ele,target)
          var duration = ele.dataset.duration || 500;
          var offset ={left:0, top: -$('header').outerHeight()};
          $.scrollTo(target,duration,{offset:offset});
        })
      });
    }
    else{
      var ele = eles[0];
      var target = document.querySelector(ele);
      //         console.log(ele,target)
      var duration = duration;
      var offset ={left:0, top: -$('header').outerHeight()};
      $.scrollTo(target,duration,{offset:offset});
    }
  },
  box_section:function(ele,slick_options){
    var selecors = document.querySelectorAll(ele);
    if(selecors){
      selecors.forEach(el => {
//         var swiper;
//         if ($(window).width()<960) {
//           $(el).removeClass('no-slider')
//         swiper = new Swiper(el, slick_options);
//         }
//         else{
//           $(el).addClass('no-slider');
//           if($(el).hasClass('swiper-initialized')){
//             swiper.destroy()
//           }
//         }
        
        var slides_count = parseInt(el.dataset.count);
        var onlyMobile = slides_count>3?false:true;
        
        if ($(window).width()<960) {
          theme_b2c.initMobileSlider(el,slick_options,onlyMobile);
        }
        else{
          if ($(ele).hasClass('slick-initialized')) {
            console.log('slider unslick')
            $(ele).slick('unslick');
            console.log('slider unslick donee')
          }
        }
      });
    }
  },
  initMobileSlider : function(slider, settings,onlyMobile=false){
    // slick on mobile
    if (!$(slider).hasClass('slick-initialized')) {
      return $(slider).slick(settings);
    }
  },
  
  b2c_videos_init:function(eles){
    var videos = document.querySelectorAll(eles);
    videos.forEach(element=>{
      var parent = element;
      if(parent){
        let video = parent.querySelector('.js-video-element'),
            content_texts = parent.nextElementSibling;
        if(!video) return;
        let playbtn = parent.querySelector('.js-play-btn');
        let loop = video.hasAttribute('loop');
        if(video && playbtn){
          let isPlayed= false;
          playbtn.addEventListener('click', function(e){
            if(video.paused == true){
              if(isPlayed==false){video.load();}
              video.play();
              isPlayed=true;
              playbtn.style.display='none';
              if(content_texts){
              	content_texts.style.display='none';
              }
            }
          })
          video.addEventListener('click', function(e){
//             console.log(video.playing)
            if(video.paused == false){
              video.pause();
              playbtn.style.display='flex';
              if(content_texts){
              	content_texts.style.display='block';
              }
            }
            else{
              if(content_texts){
              	content_texts.style.display='none';  
              }
              video.play();
              playbtn.style.display='none';
            }
          })
          if(loop== false){
            addListenerMulti(video,'loadstart play playing', function(e){
//               console.log(video.ended)
              if(video.ended){
                playbtn.style.display='flex';
                if(content_texts){
                  content_texts.style.display='block';
                }
              }
            });
          }
          
        }
      }
    })
  },
  collection_filters:function(){
    
    $(".plp-filter-icon").on('click',function(e){
      e.preventDefault();
      show_filter();
    })
    $(".close-sidebar").on('click',function(e){
      e.preventDefault();
      var sortby = $(this).parents('.filter-wrapper').hasClass('js-plp-sortby')?true:false;
//       console.log(sortby)
      hide_filter(sortby);
    })

    $('.plp-sortby-icon').on('click',function(e){
      e.preventDefault();
      show_filter(true);
    })
  },
  initReadmore:function(){
    $('[data-custom-readmore="true"]').each(function(inx,ele){
      var parent = $(this),
          dots = parent.find('.dots'),
          moreText =parent.find('.more'),
          smallText =parent.find('.small_content'),
          btnText = parent.siblings('.myBtn');
      btnText.on('click',function(e){
//         console.log(parent,dots,moreText,btnText,dots.is(':visible'))
        if(dots.is(':visible') == false){
          dots.css({'display':'inline'});
          btnText.text('Read more');
          moreText.hide();
          smallText.show();
          parent.removeClass('active-readmore');
        }
        else{
          parent.addClass('active-readmore');
          dots.css({'display':'none'});
          btnText.text('Read less');
          smallText.hide();
          moreText.css({'display':'inline'});
        }
      })

    })
  },
  
  initStyleGuideSteps:function(){
    $('.b2c-quiz-newsletter').removeAttr('style')
    $('.b2c-newsletter-thanks').addClass('hidden');
    var quiz_answers = [];
    $('.js-trigger-start-over').on('click',function(e){
      window.location.reload(true)
    })
    window.quiz_prod1 = [],
    window.quiz_prod2 = [],
    window.quiz_prod3 = [];
    window.ques_7_deciders=[
      "cool:skinfair:mbrown",
      "warm:skinfair:mbrown",
      "cool:skinmedium:mbrown",
      "warm:skinmedium:mbrown",
      "cool:skinlight:dbrown",
      "warm:skinlight:dbrown",
      "cool:skinmedium:dbrown",
      "warm:skinmedium:dbrown"
    ];

    $('[data-prev]').on('click',function(e){
      e.preventDefault();
      var quiz_step = $(this).closest('.b2c-quiz-step'),
          next_step = quiz_step.next(),
          prevPathNo = $(this).attr('data-step'),
          prevQues = $('.b2c-quiz-question-section:eq('+(prevPathNo)+')'),
          prev_step = (prevPathNo != undefined)?prevQues:quiz_step.prev();
      if(next_step.find('.steps-main-wapper').length && (next_step.hasClass('b2c-quiz-question-section') || next_step.hasClass('b2c-quiz-step') )){
        $('.steps-main-wapper').removeClass('active');
        prev_step.find('.steps-main-wapper').addClass('active');
        $("html, body").stop().animate({scrollTop:0}, 500, 'swing', function() {});
      }
    });
//     console.clear()
    $('[data-next]').on('click',function(e){
      e.preventDefault();
      var quiz_step = $(this).closest('.b2c-quiz-question-section'),
          current_step = quiz_step.find('.inner-content-wrapper'),
          step_wrapper = quiz_step.find('.steps-main-wapper'),
          nextPathNo = current_step.find('input[type="radio"]:checked').attr('data-next-step'),
          nextQues = $('.b2c-quiz-question-section:eq('+(nextPathNo)+')'),
          next_step =(nextPathNo)? nextQues: quiz_step.next(),
          prev_step = quiz_step.prev(),
          group1=(quiz_step.find('.steps-main-wapper').attr('data-product1_group')),
          group2=(quiz_step.find('.steps-main-wapper').attr('data-product2_group')),
          group3=(quiz_step.find('.steps-main-wapper').attr('data-product3_group')),
          current_stepNo = step_wrapper.attr('data-step-no'),
          Next_step_no = next_step.find('.steps-main-wapper').attr('data-step-no');;
//       console.log(Next_step_no)
      var selected_ans = {key:"step_"+current_stepNo,answer:current_step.find('input[type="radio"]:checked').val()};
      var tag_found = 0;
//       console.log('current_stepNo',$('.steps-main-wapper.active').attr('data-step-no'))
      
      var isignore = $(this).attr('data-ignore');
//       console.log(isignore)
      if(selected_ans){
//         console.log(selected_ans)
        if(current_stepNo == 1 || current_stepNo == 2 ||  current_stepNo == 3){
          window.quiz_prod1=[];
          quiz_answers=[];
        }
        
//         if(current_stepNo == 5){
//           var json = $.grep(window.quiz_prod1, function (el, idx) { return el.key != "step_"+current_stepNo });
//           quiz_answers = json;
//           console.log(quiz_answers)
// //           window.quiz_prod1.pop();
//         }
        if(current_stepNo == 5){
          window.quiz_prod2=[];
          quiz_answers.pop();
          quiz_answers.pop();
        }
        
        

        if(current_stepNo != 5){
          if(group1 != undefined){
            if(group1 == true || group1 == 'true') if(window.quiz_prod1.indexOf(selected_ans)==-1){
              var json = $.grep(window.quiz_prod1, function (el, idx) { return el.key != "step_"+current_stepNo });
//               console.log(json,"step_"+current_stepNo)
              window.quiz_prod1 = json;
              window.quiz_prod1.push(selected_ans);
            }
          }
        }
        if(group2 != undefined){          
          if(group2 == true || group2 == 'true') if(window.quiz_prod2.indexOf(selected_ans)==-1){
            var json = $.grep(window.quiz_prod2, function (el, idx) { return el.key != "step_"+current_stepNo });
            window.quiz_prod2 = json;
            window.quiz_prod2.push(selected_ans)
          }
            }
        if(group3 != undefined){
          if(group3 == true || group3 == 'true') if(window.quiz_prod3.indexOf(selected_ans)==-1){
            var json = $.grep(window.quiz_prod3, function (el, idx) { return el.key != "step_"+current_stepNo });
            window.quiz_prod3 = json;
//             console.log(json)
            window.quiz_prod3.push(selected_ans);
          }
            }
        if(quiz_answers.indexOf(selected_ans)==-1){quiz_answers.push(selected_ans);}
        
      }
      if(selected_ans == undefined && next_step.find('.steps-main-wapper').length && next_step.hasClass('b2c-quiz-step') && isignore != 'true' ){
        alert('Please select one answer');
        return false;
      }
      if(next_step.find('.steps-main-wapper').length && next_step.hasClass('b2c-quiz-step')){
        $('.steps-main-wapper').removeClass('active');
//         quiz_answers = quiz_prod1.concat(quiz_prod2);
//         console.log(quiz_answers)
//         console.log("Final: ",quiz_answers,quiz_answers.map(element=>element.answer).join(":"))
        if(!isNaN(current_stepNo)){
          var c = quiz_answers.map(element=>element.answer).join(":");
          var has_ques_7 = ques_7_deciders.indexOf(c);
//           console.log("has_ques_7 ",has_ques_7,c,ques_7_deciders)
          if(has_ques_7 > -1){
            if(current_stepNo == 6){
//               console.log('here correct')
              next_step = $('.b2c-quiz-question-section:eq('+(7)+')');
              $('.b2c-progressbar-wrapper .guide-progress-indicator:eq(1)').attr('data-step',parseInt(next_step.find('.steps-main-wapper').attr('data-step-no')-1))
              next_step.find('.steps-main-wapper').addClass('active');
            }
            else{
              next_step = (nextPathNo)? nextQues: quiz_step.next();
              $('.b2c-progressbar-wrapper .guide-progress-indicator:eq(1)').attr('data-step',parseInt(next_step.find('.steps-main-wapper').attr('data-step-no')-1))
              next_step.find('.steps-main-wapper').addClass('active');
            }
          }
          else{            
            if(current_stepNo == 6 ){
//               console.log(tag_found,'here ekse 6',Next_step_no)
              if(!isNaN(Next_step_no)){
//                 console.log(tag_found,'here ekse inner 6',Next_step_no)
                next_step = (nextPathNo)? nextQues: quiz_step.next().next();
                $('.b2c-progressbar-wrapper .guide-progress-indicator:eq(1)').attr('data-step',parseInt(next_step.find('.steps-main-wapper').attr('data-step-no')-1))
                next_step.find('.steps-main-wapper').addClass('active');
              }
              else{
//                 console.log(tag_found,'here ekse 6 iiner  else',Next_step_no)
                next_step = (nextPathNo)? nextQues: quiz_step.next();
                $('.b2c-progressbar-wrapper .guide-progress-indicator:eq(1)').attr('data-step',parseInt(next_step.find('.steps-main-wapper').attr('data-step-no')-1))
                next_step.find('.steps-main-wapper').addClass('active');
              }              
            }
            else{
//               console.log(tag_found,'here ekse 222 ')
              $('.b2c-progressbar-wrapper .guide-progress-indicator:eq(1)').attr('data-step',parseInt(next_step.find('.steps-main-wapper').attr('data-step-no')-1))
              next_step.find('.steps-main-wapper').addClass('active');
            }
          }
        }
        else{
          //for general/first start welcome step
          $('.b2c-progressbar-wrapper .guide-progress-indicator:eq(1)').attr('data-step',parseInt(next_step.find('.steps-main-wapper').attr('data-step-no')-1))
          next_step.find('.steps-main-wapper').addClass('active');
        }        
        next_step.find('[data-prev]').attr('data-step',current_stepNo);
        $("html, body").stop().animate({scrollTop:0}, 500, 'swing', function() {});
      }
      else if(next_step.hasClass('b2c-quiz-summary')){
//         console.log('group1',window.quiz_prod1.toString(),'group2',window.quiz_prod2.toString(),'group3',window.quiz_prod3.toString())
        $.each($('.inner-content-wrapper input:checked'),function(){
          $(this).parents('.steps-main-wapper').attr('data-step-no'), $(this).val()
        })
        $('.steps-main-wapper').removeClass('active');
        next_step.find('.steps-main-wapper').addClass('active');
        $('.b2c-progressbar-wrapper .guide-progress-indicator:eq(1)').attr('data-step',9)
        $("html, body").stop().animate({scrollTop:0}, 500, 'swing', function() {});
      }
      else if(next_step.hasClass('b2c-quiz-result')){
        $('.b2c-progressbar-wrapper .guide-progress-indicator:eq(1)').attr('data-step',9)
        var currentTags = '',
            query = url('?sort_by');
        currentTags = window.quiz_prod1.map(element=>element.answer).join("-");
        Shopify.queryParams.sort_by = query;
        var query = '?' + $.param(Shopify.queryParams);
        var Final_query = query.replace(/\page=(\w+)&/, ''),
            urlString1 = '',
            urlString2 = '',
            urlString3 = '';
        var all_reqs = [];
        console.log("FINAL URL::",query,currentTags)
        urlString1 = '/collections/cosmetics-collection/'+ currentTags + query+'&view=quiz-result';
        all_reqs.push(urlString1);
        urlString2 = '/collections/cosmetics-collection/'+ window.quiz_prod2.map(element=>element.answer).join("-") + query+'&view=quiz-result';
        all_reqs.push(urlString2);
        urlString3 = '/collections/cosmetics-collection/'+ window.quiz_prod3.map(element=>element.answer).join("-") + query+'&view=quiz-result';
        all_reqs.push(urlString3);
        
        
        
        var prod_res = fetch_prods(all_reqs);
        console.log("fetch_prods::",all_reqs,prod_res)
        var final_prods_count = 0,ids_arr = [];
        prod_res.then(function(res){
          console.log(res)
          $('[data-quiz-result]').empty();
          for(var i=0;i<res.length;i++){
//             console.log(res[i])
            var ele = res[i];
            var html_data = new DOMParser().parseFromString(ele, "text/html");
            var found_prod = $(html_data).find('.one-whole #product-grid').find('.grid__item:eq(0)');
            console.log("html_data::",html_data,found_prod)
            if(found_prod.length){
              var id = found_prod.attr('data-first-variant-id');
              found_prod.find('.product_image a').attr('target','_blank');
              ids_arr.push(id);
              final_prods_count = final_prods_count+1;
              $('[data-quiz-result]').append(found_prod);
            }
          }
          if(final_prods_count>0){
            $('.result-loader').hide();
            $('[data-quiz-atc-wrapper],[data-quiz-result]').removeClass('hide');
            $('[data-addtocart-all]').attr('data-variants',ids_arr.toString());
          }
          else{
            $('.result-loader').hide();
            $('[data-quiz-result]').html('No matching products found');
            $('[data-quiz-result]').removeClass('hide');
            $('[data-quiz-atc-wrapper]').addClass('hide');
          }
        });
        
        
        $('.steps-main-wapper').removeClass('active');
        next_step.find('.steps-main-wapper').addClass('active');
        $("html, body").stop().animate({scrollTop:0}, 500, 'swing', function() {});
      }
    });
    
    $('body').on('click','.show_email_signup',function(e){
      var parent = $(this).parents('.steps-main-wapper');
      parent.removeClass('active');
      $('.b2c-quiz-question-section.b2c-quiz-summary:not(.b2c-quiz-featured-text) .steps-main-wapper').addClass('active');
      $("html, body").stop().animate({scrollTop:0}, 500, 'swing', function() {});
    })
    $('body').on('click','[data-addtocart-all]',function(){
      var text = $(this).find('span.text');
      $('[data-addtocart-all]').find('span.text').text('Adding...')
      var ids = String($(this).attr('data-variants')).split(',');
      var id_ar=[];
      for(var i=0;i<ids.length;i++){
        CartJS.addItem(ids[i], 1);
      }
      window.setTimeout(function() {
        $('[data-addtocart-all]').find('span.text').text('Added!')
        
        window.setTimeout(function() {
          $('[data-addtocart-all]').find('span.text').text('Add all to your cart')
        },1000)
        
      },2000)
      
      
//       text.text('Add all to your cart');
    }) 
    
    
    $('body').on('click','.quiz_newsletter_submit',function(e){
      $(this).text('Subscribing...');
      window.setTimeout(function() {
        $(this).text('Show my code');
      },1000)
    })
    $('body').on('click','.js-show-my-result',function(e){
      e.preventDefault();
      $('.steps-main-wapper.active').removeClass('active');
      $('.b2c-quiz-result .steps-main-wapper').addClass('active');
    })
    
    $('body').on('click','.js-copy',function(e){
      copyToClipboard("js-copy");
      $('.copied-msg').addClass('active')
      window.setTimeout(function() {
        $('.copied-msg').removeClass('active')
      },1000)
    })
    
    $('body').on('change','.single-choice-true input',function(e){
      var quiz_step = $(this).closest('.b2c-quiz-step');
      if(quiz_step.find('.steps-main-wapper').length){
        window.setTimeout(function() {
          quiz_step.find('[data-next]').trigger('click');
          $("html, body").stop().animate({scrollTop:0}, 500, 'swing', function() {});
        }, 350);
      }
    })
  },
  initKlaviyoForm:function(ele){
    if($(ele).length && KlaviyoSubscribe != undefined){
      KlaviyoSubscribe.attachToForms(ele, {
        hide_form_on_success: true,
        extra_properties: {
          $source: 'Cosmetics Newsletter',
          $method_type: "embed",
          $method_id: 'embed',
          $consent_version: 'Cosmetics Newsletter'
        },
        success: function ($form) {
          var email = $form.find('[name="email"]').val();
          $("html, body").stop().animate({scrollTop:0}, 500, 'swing', function() {});
          $('.b2c-quiz-newsletter').hide()
          $('.b2c-newsletter-thanks').removeClass('hidden');
          try{
            _learnq.push(['identify', { $email: email }]);
            _learnq.push(['track', 'Signed Up for Cosmetics Newsletter']);
          }
          catch(ex){
            console.log(ex)
          }
        }
      });
    }
  }
};

function fetch_prods(all_reqs){
  const commentPromises = [];
  for(var d=0;d<all_reqs.length;d++){
    // and converting to JSON using the json() method
    commentPromises.push(fetch(`${all_reqs[d]}`).then((res) => res.text()));
  }
  const allData = Promise.all([...commentPromises]);
  var result_data;
  // attach then() handler to the allData Promise
  return allData.then((res) => res );
}

$(document).ready(function(){  
  //Write code here
  
  theme_b2c.initFeaturedText();
  theme_b2c.odometerFunc('.counter-wrapper .js-counter')
  theme_b2c.scrollToDiv(['.next-section-button']);
  if(location.hash){
    if($(location.hash).length){
      setTimeout(function () {
        theme_b2c.scrollToDiv([location.hash],1500,true);
      }, 1000);
    }
  }

  $('.thumbnail .js-product_section .product_form_options:not(.product-recommendations .js-product_section .product_form_options)').each(function () {
    if ($(this).find('.selector-wrapper select').length != $(this).data('options-size')) {
      new Shopify.OptionSelectors($(this).data('select-id'), { product: $(this).data('product'), onVariantSelected: selectCallback, enableHistoryState: $(this).data('enable-state') });
    }
  });
  
  $('[data-accordion] h3').on('click',function(e){
    e.preventDefault();
    var accordion = $(this).siblings('.accordion-detail');
    accordion.toggleClass('active')
    if(accordion.hasClass('active')){
      $(this).find('.icon').text('-');
    }
    else{
      $(this).find('.icon').text('+');
    }
  })

  var slick_Options = {
    "lazyLoad": 1,
    "slidesToShow": 2,
    "draggable": true,
    "arrows": false,
    'lazyLoad':'ondemand',
    "centerMode": false,
    easing:'linear',
    "dots": true,
    "initialSlide": 0,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '60px',
        }
      }
    ]
  };
  
  theme_b2c.box_section('.featured-text-number-b2c .js-step-slick-slider',slick_Options);
  theme_b2c.box_section('.testimonial-section-b2c .step-box-design-inner',slick_Options);
  
  theme_b2c.box_section('.shopify-section--featured-collection.featured-collection-b2c .product-list',slick_Options);
  
  theme_b2c.b2c_videos_init('.js-video-wrapper');
  theme_b2c.collection_filters();
  theme_b2c.initReadmore();
  theme_b2c.initStyleGuideSteps();
  if($('body').hasClass('page-b2c-guide')){
    theme_b2c.initKlaviyoForm('#email_signup');
  }
  theme_b2c.initKlaviyoForm('.newsletter #contact_form');
  
  if(window.innerWidth < 798){
    var how_lis = $('.b2c-pdp-how-to-section ul li');
    how_lis.each(function(inx,ele){
      
      var parent = $(this);
      var texts = parent.text();
      parent.empty();
      var smallText = $('<div class="small_content">'+texts.substr(0,25)+'<span class="dots">...</span></div>');
      var largeText = $('<div class="more">'+texts+'</div>');
      var final_wrap = $('<div class="js-howto-readmore" data-custom-readmore="true"></div>');
      final_wrap.append(smallText).append(largeText);
      var btn = $('<button class="myBtn">+</button>');
      parent.append(final_wrap);
      parent.append(btn);
      
      var  dots = parent.find('.dots'),
          moreText =parent.find('.more'),
          smallText =parent.find('.small_content'),
          btnText = parent.siblings('.myBtn');
      btn.click(function(e){
//         console.log('btnText clicked',dots.is(':visible'))
        if(dots.is(':visible') == false){
          dots.css({'display':'inline'});
          btn.text('+');
          moreText.hide();
          smallText.show();
          parent.removeClass('active-readmore');
        }
        else{
          parent.addClass('active-readmore');
          dots.css({'display':'none'});
          btn.text('-');
          smallText.hide();
          moreText.css({'display':'inline'});
        }
      })
    })
  }

  
  
  /*********** B2C PLP readmore button ************/
  $(".description-collection .morelink").click(function(){
    $(".description-collection").toggleClass("active-readmore");
  });

  var thumb_total = $('.js-b2c-product-gallery-nav').attr('data-thumbs-total');
  var min_total = 6;
  $('.js-b2c-product-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    lazyLoad: 'ondemand',
    fade: true,
    asNavFor: (thumb_total>min_total)?'.js-b2c-product-gallery-nav':false,
    responsive: [
      {
        breakpoint: 799,
        settings: {
          fade: false,
          dots: true,
          slidesToShow: 1,
          initialSlide:0,
          centerMode: true,
          centerPadding: '0px',
        }
      }
    ]
  });
  if(thumb_total>min_total){
    $('.js-b2c-product-gallery-nav').slick({
      slidesToShow: 6,
      initialSlide:0,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: true,
      centerMode: false,
      focusOnSelect: true,
      arrows: false,
      cssEase:"ease",
      easing:"linear",
    });
  }

  $('.upsell-slider-wapper-b2c').slick({
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    infinite: true,
    speed: 300,
    slidesToShow: 1
  });
  
  $('.js-disable-slider .main-slider').on('click',function(e){
    e.preventDefault();
    var index = $(this).index();
    $('.js-disable-slider .main-slider').removeClass('active');
    $(this).addClass('active');
//     console.log(index)
    $('.js-b2c-product-gallery').slick('slickGoTo',index);
  });
  
  /*Upsell Add to cart actions*/
  $('body').on('click','.add-button-section a',function(e){
    var this_ele = $(this);
    this_ele.text('Adding...');
    window.setTimeout(function() {
      this_ele.text('Add');
    }, 1300);
  });
  $(document).on('click','.cart-upsell-pluse-icon',function(e){
    e.preventDefault();
    var atc_btn = $(this).closest('.upsell-slide').find('.upsell-atc');
    atc_btn.trigger('click')
//     console.log(atc_btn)
  });
  /*Upsell Add to cart actions*/
  

  if ($('.blog-article__main').length) {
    if ($(window).width() < 798) {
      //             $(".slick-carousel").slick({
      //                 infinite: !1,
      //                 'arrows': !0,
      //                 dots: !1,
      //                 slidesToShow: 2,
      //             })
      $(".slick-carousel").flickity({
        "imagesLoaded": !0,
        "draggable": true,
        "wrapAround": !1,
        "cellAlign": 'center',
        "pageDots": !1,
        "contain": !0,
        groupCells: !0,
        "initialIndex": 0,
        freeScroll: !0
      })
    }
  }
  //Write code above
});

/********Third Party Plugins, starts from below *************/

/*!
 * jquery.counterup.js 2.1.0
 *
 * Copyright 2013, Benjamin Intal http://gambit.ph @bfintal
 * Released under the GPL v2 License
 *
 * Amended by Jeremy Paris, Ciro Mattia Gonano and others
 *
 * Date: Feb 24, 2017
 */
/*!function(t){"use strict";t.fn.counterUp=function(e){var a,n=t.extend({time:400,delay:10,offset:100,beginAt:0,formatter:!1,context:"window",onStart:function(){},callback:function(){}},e);return this.each(function(){var u=t(this),o={time:t(this).data("counterup-time")||n.time,delay:t(this).data("counterup-delay")||n.delay,offset:t(this).data("counterup-offset")||n.offset,beginAt:t(this).data("counterup-beginat")||n.beginAt,context:t(this).data("counterup-context")||n.context};e.onStart.call(this);u.waypoint(function(t){!function(){var t=[],e=o.time/o.delay,r=u.attr("data-num")?u.attr("data-num"):u.text(),i=/[0-9]+,[0-9]+/.test(r),c=((r=r.replace(/,/g,"")).split(".")[1]||[]).length;o.beginAt>r&&(o.beginAt=r);var s=/[0-9]+:[0-9]+:[0-9]+/.test(r);if(s){var f=r.split(":"),l=1;for(a=0;f.length>0;)a+=l*parseInt(f.pop(),10),l*=60}for(var d=e;d>=o.beginAt/r*e;d--){var p=parseFloat(r/e*d).toFixed(c);if(s){p=parseInt(a/e*d);var h=parseInt(p/3600)%24,m=parseInt(p/60)%60,g=parseInt(p%60,10);p=(h<10?"0"+h:h)+":"+(m<10?"0"+m:m)+":"+(g<10?"0"+g:g)}if(i)for(;/(\d+)(\d{3})/.test(p.toString());)p=p.toString().replace(/(\d+)(\d{3})/,"$1,$2");n.formatter&&(p=n.formatter.call(this,p)),t.unshift(p)}u.data("counterup-nums",t),u.text(o.beginAt);u.data("counterup-func",function(){u.data("counterup-nums")?(u.html(u.data("counterup-nums").shift()),u.data("counterup-nums").length?setTimeout(u.data("counterup-func"),o.delay):(u.data("counterup-nums",null),u.data("counterup-func",null),n.callback.call(this))):n.callback.call(this)}),setTimeout(u.data("counterup-func"),o.delay)}(),this.destroy()},{offset:o.offset+"%",context:o.context})})}}(jQuery);
*/
/**
 * Copyright (c) 2007 Ariel Flesler - aflesler ○ gmail • com | https://github.com/flesler
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 2.1.3
 */
;(function(factory){'use strict';if(typeof define==='function'&&define.amd){define(['jquery'],factory)}else if(typeof module!=='undefined'&&module.exports){module.exports=factory(require('jquery'))}else{factory(jQuery)}})(function($){'use strict';var $scrollTo=$.scrollTo=function(target,duration,settings){return $(window).scrollTo(target,duration,settings)};$scrollTo.defaults={axis:'xy',duration:0,limit:true};function isWin(elem){return!elem.nodeName||$.inArray(elem.nodeName.toLowerCase(),['iframe','#document','html','body'])!==-1}function isFunction(obj){return typeof obj==='function'}$.fn.scrollTo=function(target,duration,settings){if(typeof duration==='object'){settings=duration;duration=0}if(typeof settings==='function'){settings={onAfter:settings}}if(target==='max'){target=9e9}settings=$.extend({},$scrollTo.defaults,settings);duration=duration||settings.duration;var queue=settings.queue&&settings.axis.length>1;if(queue){duration/=2}settings.offset=both(settings.offset);settings.over=both(settings.over);return this.each(function(){if(target===null){return}var win=isWin(this),elem=win?this.contentWindow||window:this,$elem=$(elem),targ=target,attr={},toff;switch(typeof targ){case 'number':case 'string':if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)){targ=both(targ);break}targ=win?$(targ):$(targ,elem);case 'object':if(targ.length===0){return}if(targ.is||targ.style){toff=(targ=$(targ)).offset()}}var offset=isFunction(settings.offset)&&settings.offset(elem,targ)||settings.offset;$.each(settings.axis.split(''),function(i,axis){var Pos=axis==='x'?'Left':'Top',pos=Pos.toLowerCase(),key='scroll'+Pos,prev=$elem[key](),max=$scrollTo.max(elem,axis);if(toff){attr[key]=toff[pos]+(win?0:prev-$elem.offset()[pos]);if(settings.margin){attr[key]-=parseInt(targ.css('margin'+Pos),10)||0;attr[key]-=parseInt(targ.css('border'+Pos+'Width'),10)||0}attr[key]+=offset[pos]||0;if(settings.over[pos]){attr[key]+=targ[axis==='x'?'width':'height']()*settings.over[pos]}}else{var val=targ[pos];attr[key]=val.slice&&val.slice(-1)==='%'?parseFloat(val)/100*max:val}if(settings.limit&&/^\d+$/.test(attr[key])){attr[key]=attr[key]<=0?0:Math.min(attr[key],max)}if(!i&&settings.axis.length>1){if(prev===attr[key]){attr={}}else if(queue){animate(settings.onAfterFirst);attr={}}}});animate(settings.onAfter);function animate(callback){var opts=$.extend({},settings,{queue:true,duration:duration,complete:callback&&function(){callback.call(elem,targ,settings)}});$elem.animate(attr,opts)}})};$scrollTo.max=function(elem,axis){var Dim=axis==='x'?'Width':'Height',scroll='scroll'+Dim;if(!isWin(elem)){return elem[scroll]-$(elem)[Dim.toLowerCase()]()}var size='client'+Dim,doc=elem.ownerDocument||elem.document,html=doc.documentElement,body=doc.body;return Math.max(html[scroll],body[scroll])-Math.min(html[size],body[size])};function both(val){return isFunction(val)||$.isPlainObject(val)?val:{top:val,left:val}}$.Tween.propHooks.scrollLeft=$.Tween.propHooks.scrollTop={get:function(t){return $(t.elem)[t.prop]()},set:function(t){var curr=this.get(t);if(t.options.interrupt&&t._last&&t._last!==curr){return $(t.elem).stop()}var next=Math.round(t.now);if(curr!==next){$(t.elem)[t.prop](next);t._last=this.get(t)}}};return $scrollTo});

